import {HttpHeaders} from '@angular/common/http';
import {
  AbsenceReason,
  AbsenceV2ServiceInterface,
  Configuration,
  GetAbsenceEntriesResponse,
  GetAbsenceReasonsResponse,
  Response
} from '@gt-api';
import {AbsenceMocks} from '@testhelper/mocks/absence-mocks';
import {Observable, of} from 'rxjs';

export class AbsenceV2ServiceStub implements AbsenceV2ServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  private absenceEntries: GetAbsenceEntriesResponse = {
    code: 200,
    message: '',
    exception: '',
    absenceEntries: AbsenceMocks.absenceEntries
  };

  getAbsenceEntries2(oname): Observable<GetAbsenceEntriesResponse> {
    return of(this.absenceEntries);
  }

  getAbsenceReasonsForUser1(organization?: string, login?: string, locale?: string): Observable<GetAbsenceReasonsResponse> {
    return of({
      code: 200,
      absenceReasons: AbsenceMocks.absenceReasons
    });
  }

  setAbsenceReasonForUser1(organization?: string, login?: string, updateAllAbsences?: boolean, body?: AbsenceReason): Observable<Response> {
    return of({
      code: 200
    });
  }
}
